<em class="pi pi-map-marker icon"></em>

<span>{{ globals.user.warehouse.warehouseN }} | {{ globals.user.country }} {{ environmentName | translate }}</span>

